/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="95.58"
        height="54.59"
        viewBox="0 0 95.58 54.59"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M44.19 42A6.8 6.8 0 1 1 42 51.4a6.8 6.8 0 0 1 2.19-9.4"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="m53.66 45.39 20.64-24.1-24.1 20.63 3.46 3.47z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M74 20.91 49.87 41.5a.52.52 0 0 0 0 .72l3.46 3.46a.49.49 0 0 0 .69 0L74.7 21.6a.5.5 0 0 0-.73-.69Zm-4.25 5L53.63 44.65 50.93 42Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#0e497b"
          d="M47.79 0a47.79 47.79 0 0 1 47.79 47.79A1.26 1.26 0 0 1 94.5 49H83.13a1.25 1.25 0 0 1-.13-2.45h10.07v-.25A45.29 45.29 0 0 0 48.5 2.5h-.75A45.3 45.3 0 0 0 2.5 46.3v.2h10a1.24 1.24 0 0 1 1.24 1.12v.13A1.26 1.26 0 0 1 12.62 49H1.25A1.25 1.25 0 0 1 0 47.75 47.79 47.79 0 0 1 47.79 0Z"
          className="icon-fill icon-base"/>
        <path
          fill="#0e497b"
          d="M14 14a1.22 1.22 0 0 1 1.66-.09l.1.09 7.93 7.92A1.25 1.25 0 0 1 22 23.79l-.1-.09-7.9-7.92A1.25 1.25 0 0 1 14 14ZM47.79 0A1.26 1.26 0 0 1 49 1.12V12.5a1.25 1.25 0 0 1-2.49.13V1.25A1.25 1.25 0 0 1 47.79 0Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'DialGaugeIcon';

export default Icon;
